/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseTableViewDto } from '../../models/recourse-table-view-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeleteTableViewFromRegisteredUser$Params {
  tableViewId: number;
}

export function deleteTableViewFromRegisteredUser(
  http: HttpClient,
  rootUrl: string,
  params: DeleteTableViewFromRegisteredUser$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecourseTableViewDto>>> {
  const rb = new RequestBuilder(rootUrl, deleteTableViewFromRegisteredUser.PATH, 'delete');
  if (params) {
    rb.path('tableViewId', params.tableViewId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecourseTableViewDto>>;
    }),
  );
}

deleteTableViewFromRegisteredUser.PATH = '/service/v1/tableView/registeredUser/{tableViewId}';
